export class TranslationEntityItem {
    culture: string;
    translation: string;
}

export class TranslationEntity {
    key: string;
    items: TranslationEntityItem[];
}